import styled from 'styled-components';

import { Infobox } from '@hivebrite/design-system/Infobox';
import { Link } from '@hivebrite/design-system/Link';

import { type InfoBoxProps } from 'hb-react/shared/apps/JobForm/types';

// Note that this component is only displayed in the BO there is a check on JobForm before rendering it
export const CreatedFrom = ({ children, parent, parentType }: InfoBoxProps) => {
  const isFromTopic = parentType === 'Topics::Topic';

  if (!parent) {
    return null;
  }

  if (isFromTopic && parent.network_id) {
    return (
      <Infobox title={children || ''}>
        <StyledLink
          to={Routes.edit_backoffice_network_topic_path(
            parent.network_id,
            parent.id,
          )}
          rel="nofollow"
          ml={1}
        >
          {parent.name}
        </StyledLink>
      </Infobox>
    );
  }

  return <Infobox title={`${children} ${parent.title}`} />;
};

const StyledLink = styled(Link)`
  text-decoration: none;
`;
